import { render, staticRenderFns } from "./FiltersCard.vue?vue&type=template&id=60860f03&scoped=true&"
import script from "./FiltersCard.vue?vue&type=script&lang=js&"
export * from "./FiltersCard.vue?vue&type=script&lang=js&"
import style0 from "./FiltersCard.vue?vue&type=style&index=0&id=60860f03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60860f03",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60860f03')) {
      api.createRecord('60860f03', component.options)
    } else {
      api.reload('60860f03', component.options)
    }
    module.hot.accept("./FiltersCard.vue?vue&type=template&id=60860f03&scoped=true&", function () {
      api.rerender('60860f03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/FiltersCard.vue"
export default component.exports